/*
 * Footer behaviour for the tryrosabella.com clone.
 *
 * Two things `rosabella.js` does not already cover:
 *
 *  1. Dawn's scroll-in animation. The footer's blocks ship `scroll-trigger
 *     animate--slide-in`, which is `opacity: .01` until an IntersectionObserver
 *     takes the `scroll-trigger--offscreen` class back off. The class is only
 *     ever added by this script, so if the script fails to load the footer is
 *     visible rather than invisible — same fallback as Dawn.
 *  2. The country selector's search field, reset button and close button.
 *     `rosa-lform` in rosabella.js only opens the disclosure and submits the
 *     chosen country.
 *
 * Scoped to `.rbx .footer` so it never touches the sibling cloned sections.
 */
(function () {
  'use strict';

  function init(footer) {
    initScrollTriggers(footer);
    initCountryFilter(footer);
  }

  /* ---- Dawn's animations.js, for this footer only --------------------- */
  function initScrollTriggers(footer) {
    var elements = Array.prototype.slice.call(footer.querySelectorAll('.scroll-trigger'));
    if (!elements.length || typeof IntersectionObserver === 'undefined') return;

    var observer = new IntersectionObserver(
      function (entries, obs) {
        entries.forEach(function (entry, index) {
          var target = entry.target;
          if (entry.isIntersecting) {
            if (target.classList.contains('scroll-trigger--offscreen')) {
              target.classList.remove('scroll-trigger--offscreen');
              if (target.hasAttribute('data-cascade')) {
                target.setAttribute('style', '--animation-order: ' + index + ';');
              }
            }
            obs.unobserve(target);
          } else {
            target.classList.add('scroll-trigger--offscreen');
            target.classList.remove('scroll-trigger--cancel');
          }
        });
      },
      { rootMargin: '0px 0px -50px 0px' }
    );

    elements.forEach(function (element) {
      observer.observe(element);
    });
  }

  /* ---- Country selector search / reset / close ------------------------ */
  function initCountryFilter(footer) {
    var selector = footer.querySelector('.country-selector');
    if (!selector) return;

    var input = selector.querySelector('.country-filter__input');
    var resetButton = selector.querySelector('.country-filter__reset-button');
    var closeButton = selector.querySelector('.country-selector__close-button');
    var overlay = footer.querySelector('.country-selector__overlay');
    var results = selector.querySelector('#sr-country-search-results');
    var items = Array.prototype.slice.call(selector.querySelectorAll('.disclosure__item'));

    function filter(term) {
      var needle = term.trim().toLowerCase();
      var shown = 0;
      items.forEach(function (item) {
        var name = item.querySelector('.country');
        var match = !needle || (name && name.textContent.trim().toLowerCase().indexOf(needle) > -1);
        item.hidden = !match;
        if (match) shown++;
      });
      if (resetButton) resetButton.classList.toggle('hidden', needle.length === 0);
      if (results) results.textContent = needle ? shown + ' results found' : '';
    }

    if (input) {
      input.addEventListener('input', function () {
        filter(input.value);
      });
      input.addEventListener('keydown', function (event) {
        if (event.code && event.code.toUpperCase() === 'ESCAPE') close();
      });
    }

    if (resetButton) {
      resetButton.addEventListener('click', function (event) {
        event.preventDefault();
        if (input) {
          input.value = '';
          input.focus();
        }
        filter('');
      });
    }

    function close() {
      var wrapper = footer.querySelector('.disclosure__list-wrapper');
      var button = footer.querySelector('.disclosure__button');
      if (wrapper) wrapper.hidden = true;
      if (button) {
        button.setAttribute('aria-expanded', 'false');
        button.focus();
      }
    }

    if (closeButton) closeButton.addEventListener('click', close);
    if (overlay) overlay.addEventListener('click', close);
  }

  function boot() {
    var footers = document.querySelectorAll('.rbx .footer');
    Array.prototype.forEach.call(footers, function (footer) {
      if (footer.dataset.rosaFooterReady) return;
      footer.dataset.rosaFooterReady = '1';
      init(footer);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Theme editor re-renders the section without a page load.
  document.addEventListener('shopify:section:load', boot);
})();
